import { ref, push, set } from 'firebase/database';
import { auth, db } from './firebase';

// A lightweight trail of who did what to sensitive records (approvals,
// suspensions, refunds, admin-account creation) — not a full compliance
// audit system, just enough to answer "who approved this pharmacy" later.
export async function logAdminAction(action, target, details = {}) {
  try {
    const entryRef = push(ref(db, 'adminAuditLog'));
    await set(entryRef, {
      id: entryRef.key,
      action,
      target,
      details,
      performedBy: auth.currentUser?.email || 'unknown',
      performedAt: new Date().toISOString(),
    });
  } catch (e) {
    console.error('Audit log write failed', e);
  }
}
